import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Paper,
  Chip,
  Avatar,
  Stack,
} from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import FlightIcon from "@mui/icons-material/Flight";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const upcomingTransactions = [
    { date: "2024-06-10", amount: 2500, remarks: "EMI - Home Loan", type: "DR" },
    { date: "2024-06-15", amount: 1200, remarks: "Auto Debit - Insurance", type: "DR" },
    { date: "2024-06-20", amount: 5000, remarks: "Salary", type: "CR" },
  ];

  const accounts = [
    {
      accountNumber: user?.accountNumber || "AC123456789",
      type: user?.accountType || "Savings",
      balance: user?.availableBalance ?? 25000,
      holder: user?.name || "Customer",
    },
  ];

  const personalizedProducts = [
    { name: "Gold Credit Card", desc: "Low interest, high rewards", icon: <CreditCardIcon color="primary" /> },
    { name: "Personal Loan Offer", desc: "Pre-approved up to ₹5,00,000", icon: <MonetizationOnIcon color="success" /> },
    { name: "Travel Insurance", desc: "Exclusive rates for you", icon: <FlightIcon color="info" /> },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e3eafe 0%, #f5f7fa 100%)",
        py: { xs: 2, md: 6 },
        px: { xs: 1, md: 4 },
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12} lg={8} md={7}>
          <Typography
            variant="h4"
            fontWeight={700}
            mb={2}
            textAlign={{ xs: "center", md: "left" }}
            sx={{
              color: "#1976d2",
              textShadow: "0 2px 8px #e3eafe",
            }}
          >
            Good {new Date().getHours() < 12 ? "Morning" : "Afternoon"}, {user?.name || "Customer"}!
          </Typography>
          <Card
            elevation={6}
            sx={{
              mb: 3,
              background: "linear-gradient(90deg, #6B73FF 0%, #000DFF 100%)",
              color: "#fff",
              borderRadius: 4,
              boxShadow: "0 4px 24px rgba(107,115,255,0.15)",
            }}
          >
            {/* <CardContent>
              <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                <AccountBalanceWalletIcon fontSize="large" />
                <Typography variant="h6" fontWeight={600}>
                  Your Balance
                </Typography>
              </Stack>
              <Typography
                variant="h3"
                fontWeight={700}
                sx={{
                  wordBreak: "break-word",
                  fontSize: { xs: "2rem", md: "3rem" },
                  mb: 1,
                  color: "#fff",
                  textShadow: "0 2px 8px #000DFF",
                }}
              >
                ₹{user?.availableBalance ?? "25,000"}
              </Typography>
              <Divider sx={{ my: 2, borderColor: "#fff", opacity: 0.3 }} />
              <Typography variant="subtitle1" fontWeight={600} mb={1}>
                Upcoming Transactions
              </Typography>
              <List
                sx={{
                  maxHeight: { xs: 180, md: 220 },
                  overflowY: "auto",
                  pr: 1,
                }}
              >
                {upcomingTransactions.map((tx, idx) => (
                  <ListItem key={idx} sx={{ py: 0.5 }}>
                    <ListItemText
                      primary={
                        <span>
                          <Chip
                            icon={<TrendingUpIcon />}
                            label={tx.type === "CR" ? "Credit" : "Debit"}
                            color={tx.type === "CR" ? "success" : "error"}
                            size="small"
                            sx={{ mr: 1 }}
                          />
                          <strong>₹{tx.amount}</strong> - {tx.remarks}
                        </span>
                      }
                      secondary={tx.date}
                    />
                  </ListItem>
                ))}
              </List>
            </CardContent> */}
          </Card>
          <Card elevation={2} sx={{ mb: 3, borderRadius: 4 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Account Management
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => navigate("/admin/transfer")}
                  >
                    Fund Transfer
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => navigate("/admin/beneficiaries")}
                  >
                    Beneficiaries
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => navigate("/admin/account-summary")}
                  >
                    Account Summary
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    color="info"
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => navigate("/admin/account-details")}
                  >
                    Account Details
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    color="warning"
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => alert("Auto Debit/Recurring Setup Coming Soon!")}
                  >
                    Auto Debit / Recurring
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="outlined"
                    fullWidth
                    color="error"
                    size="large"
                    sx={{ minHeight: 48, fontWeight: 600, fontSize: "1rem" }}
                    onClick={() => alert("Stop Payment Coming Soon!")}
                  >
                    Stop Payment
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={4} md={5}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, borderRadius: 4 }}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Your Accounts
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {accounts.map((acc, idx) => (
              <Box key={idx} sx={{ mb: 2 }}>
                <Typography>
                  <strong>Account Number:</strong> {acc.accountNumber}
                </Typography>
                <Typography>
                  <strong>Type:</strong> {acc.type}
                </Typography>
                <Typography>
                  <strong>Holder:</strong> {acc.holder}
                </Typography>
                <Typography>
                  <strong>Balance:</strong> <span style={{ color: "#1976d2", fontWeight: 700 }}>₹{acc.balance}</span>
                </Typography>
                <Divider sx={{ my: 1 }} />
              </Box>
            ))}
            <Typography variant="h6" fontWeight={600} mt={3} gutterBottom>
              Personalized Products
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              {personalizedProducts.map((prod, idx) => (
                <Grid item xs={12} key={idx}>
                  <Card
                    elevation={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 1,
                      flexDirection: { xs: "column", sm: "row" },
                      textAlign: { xs: "center", sm: "left" },
                      background: "#f5f7fa",
                      borderRadius: 2,
                    }}
                  >
                    <Avatar sx={{ bgcolor: "#e3eafe", color: "#222", mr: { sm: 2, xs: 0 }, mb: { xs: 1, sm: 0 } }}>
                      {prod.icon}
                    </Avatar>
                    <Box>
                      <Typography fontWeight={600}>{prod.name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {prod.desc}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
